import { registerPlugin } from '@capacitor/core';

const SavePassword = registerPlugin<ISavePassword>('SavePassword');
export interface Options {
    username: string;
    password: string;
}

export interface ISavePassword {
    promptDialog(options: Options): Promise<void>;
}

export default SavePassword;
